import template from './contract.edit.html';
import controller from './contract.edit.controller';
import './contract.edit.scss';

let contracteditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default contracteditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/edit/contract.edit.component.js